import api from "../services/axios";

class ServiceTax {
  async save(taxes) {
    const { data } = await api.post('/impostos', taxes)
    return data
  }

  async update(taxes) {
    await api.put(`/impostos/${taxes.id}`, taxes)
  }

  async delete(tax) {
    await api.delete(`/impostos/${tax.id}?classImposto=${tax.ref}`)
  }

  async findAllRefs(filters = {}) {
    const { data } = await api.get('/impostos', { params: filters })
    return data
  }

  async fillComboBoxWithPaginate(id = '', text = '', filterType = 'includes', page, filters = {}) {
    const { data } = await api.get('/impostos/combobox/with/paginate', {
      params: { id, q: text, page, filterType, ...filters },
    })
    return data
  }

  async findById(id) {
    const { data } = await api.get(`/impostos/${id}`)
    return data
  }

  async findByRefName(refName) {
    const { data } = await api.get(`/impostos/find/by/${refName}`)
    return data
  }
}

export default new ServiceTax()
